import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../Componets/Header";
import {
  create_project_task,
  get_project_task,
  update_project_task,
} from "../../../../Controllers/Projects/Tasks";
import forms from "../../../../Data/Forms/Projects/Tasks/forms";
import headers from "../../../../Data/Forms/Projects/Tasks/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { convert_to_file } from "../../../../Controllers/Global";
import Headercomponent from "../../../../Componets/Formcomponents/header";
import Bodycomponent from "../../../../Componets/Formcomponents/body";
import Titlecomponent from "../../../../Componets/Formcomponents/title";
import Formdata from "../../../../Componets/Formcomponents/formdata";
import Projecttaskemployeestable from "../../../../Data/Forms/Projects/Tasks/employees";

const ProjectsTasksForm = () => {
  const { project, id } = useParams();
  let navigate = useNavigate();

  headers.navigate.path[0].path = `/app/projects/tasks/${project}`;

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [values, setValues] = useState(forms);
  const [header, setHeader] = useState(headers);

  const employeeFocus = useRef([]);

  const [employeeDetails, setEmployeeDetails] = useState([
    {
      id: "",
      description: null,
      role: "",
      hours: "",
      cost: "",
      total: 0,
    },
  ]);
  const [employeeTotals, setEmployeeTotals] = useState({
    total: "0.000",
  });

  const employeesDetailsValidation = (tabledata) => {
    let params = {};

    if (employeeDetails?.length > 0) {
      let total = employeeDetails?.length;
      let count = 0;

      let validated = [];
      employeeDetails?.map((v, i) => {
        if (count == i) {
          if (!v?.description) {
            document.getElementById(
              `description${i}`
            ).textContent = `Description is required`;
            employeeFocus.current[`description${i}`].current.focus();
          } else {
            document.getElementById(`description${i}`).textContent = ``;
            validated?.push(v);
            count++;
          }
        }
      });

      if (count == total) {
        params = {
          status: true,
          data: {
            ...tabledata,
            details: validated,
          },
        };

        return params;
      } else {
        params = {
          status: false,
          data: null,
        };

        return params;
      }
    } else {
      toast?.error("Details not found");
    }
  };

  const formdata = async (data) => {
    if (data?.status) {
      const tableEmployeedetailsvalidation = employeesDetailsValidation(
        data?.data
      );

      if (tableEmployeedetailsvalidation?.status) {
        setButtonLoader(true);

        const task = id
          ? await update_project_task({
              ...data?.data,
              id: id,
              project: project,
              employeedetails: tableEmployeedetailsvalidation?.data?.details,
            })
          : await create_project_task({
              ...data?.data,
              project: project,
              employeedetails: tableEmployeedetailsvalidation?.data?.details,
            });

        if (task?.status) {
          if (id) {
            navigate(-1);
          }

          toast?.success(task?.message);
          setButtonLoader(false);
        } else {
          toast?.error(task?.message);
          setButtonLoader(false);
        }
      }
    }
  };

  const handleData = async (task) => {
    let image = task?.image ? task?.image : "";
    let file = await convert_to_file(image);

    let project = task?.project_job?._id ? task?.project_job?._id : "";

    let name = task?.name ? task?.name : "";
    let description = task?.description ? task?.description : "";
    let number = task?.number ? task?.number : "";
    let status = task?.status ? task?.status : 0;

    let project_option = task?.project_job?._id
      ? [{ value: task?.project_job?._id, label: task?.project_job?.name }]
      : null;

    values[0].options[0].form.value = file;

    values[0].options[1].form.value = project;
    values[0].options[1].form.options = project_option;

    values[0].options[2].form.value = name;
    values[0].options[3].form.value = description;
    values[0].options[4].form.value = number;

    values[1].options[0].form.value = status;

    let employee_data = [];
    task?.employee_details?.map((value, index) => {
      employee_data?.push({
        id: value?._id,
        description: value?.description?._id,
        name: value?.description?.name,
        role: value?.description?.role?.name,
        hours: value?.hours ? value?.hours : 0,
        charges: value?.charges ? value?.charges : 0,
        total: value?.total,
      });
    });
    employeeTotals.total = task?.employee_total;

    setLoader(false);
    setValues([...values]);
    setEmployeeDetails(employee_data);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const task = await get_project_task(data);
      if (task?.status) {
        handleData(task?.data);
      } else {
        toast?.error(task?.message);
      }
    } else {
      setLoader(false);
    }

    values[0].options[1].form.params = {
      api: "get-project-jobs",
      status: 1,
      project: project,
    };
    values[0].options[1].path = `/app/projects/jobs/add/${project}`;
    setValues([...values]);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
        >
          <Bodycomponent>
            <Titlecomponent index={3} title={"Employees"} />
            <Formdata>
              <Headercomponent index={0} name={"Details"} required={true} />
              <Projecttaskemployeestable
                employeeDetails={employeeDetails}
                setEmployeeDetails={setEmployeeDetails}
                employeeTotals={employeeTotals}
                setEmployeeTotals={setEmployeeTotals}
                ref={employeeFocus}
              />
            </Formdata>
          </Bodycomponent>
        </Forms>
      </Loadercomponent>
    </Header>
  );
};

export default ProjectsTasksForm;
